app.controller("EmployeeStaffAddController", [
    "$scope", "$uibModalInstance", "Users", "StaticData", "DocumentsService", "toastr",
    function ($scope, $uibModalInstance, Users, StaticData, DocumentsService, toastr) {

        $scope.getUsers = function (name) {
            if (name.length < 1) {
                return [];
            }
            return Users.list({
                query: name
            }).then(function (data) {
                return data.docs;
            });
        };

        $scope.create = function () {
            var employer = {};
            employer.user = $scope.chosenUser._id;
            DocumentsService.staffAdd(employer).then(function () {
                $uibModalInstance.close();
            }).catch(function (err) {
                if (err.status === 400) {
                    toastr.error('', 'მიმდინარე მომხმარებელს უკვე აქვს თანამშრომლის აქტიური პროფილი.');
                }
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
